import base from './base';

export default {
  ...base,
  leftMenu: { ...base.leftMenu, summary: 'Summary' }
};
